import { render, staticRenderFns } from "./IconSvgAPSNNews.vue?vue&type=template&id=287c8214&scoped=true&"
import script from "./IconSvgAPSNNews.vue?vue&type=script&lang=js&"
export * from "./IconSvgAPSNNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c8214",
  null
  
)

export default component.exports